import { StorageType } from '../enumeration/storage-type.js';
import { EditorStorageService } from './editor-storage-service.js';

class EditorService {
  constructor(databaseName, editorHtmlConfig) {
    this._editorHtmlConfig = editorHtmlConfig;
    if (databaseName) {
      if (editorHtmlConfig && editorHtmlConfig.storageType === StorageType.LOCAL && editorHtmlConfig.storeName) {
        this._editorStorageService = new EditorStorageService(
          databaseName,
          editorHtmlConfig.storeName
        );
      }
    }
  }
  _editorStorageService = void 0;
  _editorHtmlConfig = void 0;
  _htmlStoreKey = "html";
  async readHtml() {
    if (this._editorHtmlConfig) {
      if (this._editorHtmlConfig.storageType === StorageType.LOCAL) {
        return await this._editorStorageService?.read(
          this._htmlStoreKey
        ) || "";
      } else if (this._editorHtmlConfig.storageType === StorageType.REMOTE) {
        return await this._editorHtmlConfig.reader?.() || "";
      }
    }
    return "";
  }
  async saveHtml(html) {
    if (this._editorHtmlConfig) {
      if (this._editorHtmlConfig.storageType === StorageType.LOCAL) {
        if (this._editorStorageService) {
          return await this._editorStorageService?.save(
            this._htmlStoreKey,
            html
          );
        } else {
          return false;
        }
      } else if (this._editorHtmlConfig.storageType === StorageType.REMOTE) {
        return await this._editorHtmlConfig.saver?.(html) || false;
      }
    }
    return false;
  }
}

export { EditorService };
//# sourceMappingURL=editor-service.js.map
